<template>
  <div class="form-panel">
    <p class="form-panel__title"><i class="mdi mdi-filter-variant"></i>Filtrar por</p>
    <div class="form-panel__field">
      <date-picker 
        label="Data inicial"
        dense
        :binding.sync="filter.date"
        :readOnly="false"
      />
    </div>

    <div class="form-panel__field">
      <date-picker 
        label="Data final"
        dense
        :binding.sync="filter.date_end"
        :readOnly="false"
      />
    </div>

    <v-autocomplete
      v-if="user.attributes.kind !== 'partner'"
      class="form-panel__field"
      outlined
      dense
      label="Controladores"
      :items="partners"
      item-text="name"
      item-value="id"
      v-model="filter.partners"
      multiple
      no-data-text="Nenhum Resultado"
    >
      <template v-slot:prepend-item>
        <v-list-item ripple @click="selectAllPartners">
          <v-list-item-action>
            <v-icon
              :color="
                filter.partners.length > 0 ? 'indigo darken-4' : ''
              "
            >
              {{ icon }}
            </v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              Selecionar todos
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>

    <v-autocomplete
      class="form-panel__field"
      outlined
      dense
      label="Criadores"
      :items="creators"
      item-text="name"
      item-value="id"
      v-model="filter.person_id"
      no-data-text="Nenhum Resultado"
    >
    </v-autocomplete>

    <div class="form-panel__actions">
      <v-btn 
        class="success"
        @click="submit"
      >
        <i class="mdi mdi-file-chart-outline pr-1"></i>
        Gerar Relatório
      </v-btn>
    </div>
  </div>
</template>

<script>
import DatePicker from "@/components/layout/DatePicker";
export default {
  name:"ReportFilters",
  props:{
    partners:Array,
    creators:Array,
    user:Object
  },
  components:{
    DatePicker
  },
  data() {
    return {
      filter:{
        partners:[]
      }
    }
  },
  computed: {
    likesAllPartners() {
    return this.filter.partners.length === this.partners.length;
    },
    likesSomePartners() {
      return this.filter.partners.length > 0 && !this.likesAllPartners;
    },
    icon() {
      if (this.likesAllPartners) return "mdi-close-box";
      if (this.likesSomePartners) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    }
  },
  methods: {
    submit() {
      if(!this.filter.date || !this.filter.date_end) {
        this.$toast.warning("Intervalo de tempo não definido !");
        return
      }
      if(this.user.attributes.kind === "partner") {
        this.filter.partners = [this.user.attributes.id];
      }
      this.$emit("get-report", this.filter);
    },
    selectAllPartners() {
      this.$nextTick(() => {
        let all = null;
        if (this.likesAllPartners) {
          this.filter.partners = [];
        } else {
          all = this.partners.map(e => {return e.id});
          this.filter.partners = all.slice();
        }
      });
    },
  }
}
</script>